import { Common } from '@stockbit/ui';
import Link from 'next/link';
import { useState } from 'react';
import { PasswordCancelButton, PasswordSubmitButton } from '../styled';
import { TelephoneInput } from './styled';
import changePhoneStore from './store';

const { Flex, Text } = Common;

interface NewEmailProps {
  phone: string;
  onNext: () => void;
  cancelLink: string;
  onClickCancel?: () => void;
}

function NewPhone({
  phone,
  onNext,
  cancelLink,
  onClickCancel = () => {},
}: NewEmailProps) {
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setPhone] = changePhoneStore((s) => [
    s.isLoading,
    s.setPhone,
  ]);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [country, setCountry] = useState(null);

  const handleChange = (telNumber, selectedCountry) => {
    setCountry(selectedCountry);
    setPhoneNumber(`${telNumber}`);
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    setPhone(
      phoneNumber.slice(country?.dialCode?.length),
      country?.dialCode ?? '',
    );

    onNext();
  };

  return (
    <form onSubmit={handleSubmit}>
      <Flex
        padding="0 15px 20px 15px"
        width="100%"
        direction="column"
        margin="auto"
      >
        <Text
          size="16px"
          family="bold"
          mb="15px"
          height="1.5"
          data-cy="change-phone-new-phone-label"
        >
          Masukkan Nomor Hp Baru Kamu
        </Text>
        <Flex align="center" width="100%" mb="10px">
          <Flex width="30%" align="center">
            <Text data-cy="change-phone-new-phone-current-number-label">
              No Hp Sekarang
            </Text>
          </Flex>
          <Text
            family="bold"
            data-cy="change-phone-new-phone-current-number-value"
          >
            {phone}
          </Text>
        </Flex>
        <Flex align="center" width="100%">
          <Flex width="30%" align="center">
            <Text>No Hp Baru</Text>
          </Flex>
          <Flex
            width="70%"
            data-cy="change-phone-new-phone-new-number-input-box"
          >
            <TelephoneInput
              autoFormat={false}
              country="id"
              onChange={handleChange}
              value={phoneNumber}
            />
          </Flex>
        </Flex>
      </Flex>

      <Flex mt="10px">
        <Link href={cancelLink}>
          <PasswordCancelButton
            disabled={false}
            onClick={onClickCancel}
            data-cy="change-phone-new-phone-label-cancel-btton"
          >
            Cancel
          </PasswordCancelButton>
        </Link>
        <PasswordSubmitButton
          htmlType="submit"
          type={phoneNumber.length >= 9 ? 'primary' : 'muted'}
          loading={isLoading}
          onClick={handleSubmit}
          data-cy="change-phone-new-phone-submit-button"
          disabled={phoneNumber.length < 9}
        >
          Submit
        </PasswordSubmitButton>
      </Flex>
    </form>
  );
}

export default NewPhone;
